import React from "react";
import Pod from "carbon-react/lib/components/pod";
import { Tabs, Tab } from "carbon-react/lib/components/tabs";
import ErrorBoundary from "../../../boundaries/ErrorBoundary";
import UserLogs from "./userLogsTab/UserLogs";
import UserMfaEnrollments from "./mfaEnrollmentTab/UserMfaEnrollments";
import ErrorMessage from "../../messages/ErrorMessage";
import UserRefreshTokens from "./refreshTokenTab/UserRefreshTokens";
import UserAuditLogs from "./auditLogTab/UserAuditLogs";

const UserTabs = (props) => {
  return (
    <Pod>
      <Tabs position="left" align="left" className="userTabs">
        <Tab title="Activity history" tabId={"activityhistory"}>
          <ErrorBoundary
            fallback={() => <ErrorMessage message="Failed to load log data" />}
          >
            <UserLogs user={props.user} />
          </ErrorBoundary>
        </Tab>
        <Tab title="MFA enrollments" tabId={"mfaEnrollments"}>
          <UserMfaEnrollments user={props.user} />
        </Tab>
        <Tab title="Refresh tokens" tabId={"refreshTokens"}>
          <UserRefreshTokens user={props.user} />
        </Tab>
        <Tab title="Audit logs" tabId={"auditLogs"}>
          <UserAuditLogs user={props.user} />
        </Tab>
      </Tabs>
    </Pod>
  );
};

export default UserTabs;
